/* eslint-disable */
//Strange elint error. Says className,type, text and events are missing prop validation.  But they aren't.
import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";
import { areEqualShallow } from "Utils/areEqual";
import { LeftArrow, NextArrowIcon } from "./Arrows";
import CloseIcon from "./Close";
import DirectionsIcon from "./Directions";
import TrailsIcon from "./Trails";
import DestinationsMobileIcon from "./DestinationsMobile";
import styles from "../Destinations/styles";


interface Props {
  className?: string;
  events?: any;
  text?: any;
  type: string;
  tabIndex?: number;
}

const Icon: FC<Props> = memo(({ className, type, text, events, tabIndex }: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  return {
    leftarrow: <LeftArrow {...events} className={className} />,
    trails: <button id="trails-button" className={classes.button} tabIndex={tabIndex} aria-label="Trails" {...events}><TrailsIcon {...events} className={className} /> </button>,
    directions:<button className={classes.button} tabIndex={tabIndex} aria-label="Directions" {...events}> <DirectionsIcon {...events} className={className} /> </button>,
    close: <button id="close-button" className={classes.button} tabIndex={tabIndex} aria-label="Close" {...events} > <CloseIcon {...events}  className={className} /></button>,
    currentLabel: (
      <button id="current-label-button" type="button" {...events} className={className} style={{ whiteSpace: "nowrap" }}>
        {text}
      </button>
    ),
    textLabel: <div className={classes.button} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "110px"}}>{text}</div>,
    destinationsMobile: (
      <DestinationsMobileIcon {...events} className={className} />
    ),
    nextArrow: <NextArrowIcon {...events} className={className} />,
  }[type];
}, areEqualShallow);
Icon.defaultProps = {
  className: undefined,
  events: undefined,
  text: undefined,
  tabIndex: 0,
};
export default Icon;
try {
    // @ts-ignore
    icons.displayName = "icons";
    // @ts-ignore
    icons.__docgenInfo = { "description": "", "displayName": "icons", "props": { "className": { "defaultValue": { value: "undefined" }, "description": "", "name": "className", "required": false, "type": { "name": "string" } }, "events": { "defaultValue": { value: "undefined" }, "description": "", "name": "events", "required": false, "type": { "name": "any" } }, "text": { "defaultValue": { value: "undefined" }, "description": "", "name": "text", "required": false, "type": { "name": "any" } }, "type": { "defaultValue": null, "description": "", "name": "type", "required": true, "type": { "name": "string" } }, "tabIndex": { "defaultValue": { value: 0 }, "description": "", "name": "tabIndex", "required": false, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Icons/icons.tsx#icons"] = { docgenInfo: icons.__docgenInfo, name: "icons", path: "src/shared/components/Icons/icons.tsx#icons" };
}
catch (__react_docgen_typescript_loader_error) { }